export class CurrencyModel {
  public id: string;
  public name: string;
  public shortName: string;
  public symbol: string;
  public isDefault: boolean;
}
